<template>
<div class="MTalentIndex" :style="{padding: hideHeader ? '0' : (showAppTips ? '1.98rem 0 0' : '0.88rem 0 0')}">
    <MHeader ref="mtalentheader" v-if="!hideHeader"></MHeader>
    <div class="m-body">
        <mTalentIndexContent></mTalentIndexContent>
    </div>
    <div class="serviceqrurl_pop">
        <van-popup v-model="serviceQrUrlPop" position="center">
            <div class="serviceqrurl_box">
                <img class="service_img" src="https://img.capwhale.com/capwhale_service_hr.png" alt="">
                <p class="tip_text">扫码添加专属客服</p>
                <p class="hot_line_text">热线：<span>0755-86393108</span></p>
                <img @click="serviceQrUrlPop = false" class="close_img" :src="require('@/common/images/mtalentimgs/icon_close.png')" alt="">
            </div>
        </van-popup>
    </div>
    <div class="shortcut_box">
        <div @click="serviceQrUrlPop = true">
            <img :src="require('@/common/images/mtalentimgs/shortcut1.png')" alt="">
            <span>客服</span>
        </div>
        <div @click="showRecruitPop">
            <img :src="require('@/common/images/mtalentimgs/shortcut2.png')" alt="">
            <span>招聘</span>
        </div>
    </div>
    <!-- <MTab></MTab> -->
</div>
</template>

<script>
// import MTab from 'views/mtalent/components/tab/mTab'
// import MTab from 'views/mobile/components/tab/mTab'
import MHeader from 'views/mobile/components/mheader/mHeader'
import mTalentIndexContent from 'views/mtalent/index/components/mTalentIndexContent'
import $ from 'jquery'
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'MTalentIndex',
    data() {
        return {
            show: false,
            serviceQrUrlPop: false,
            hideHeader: false
        }
    },
    created() {
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'TalentIndex'
            })
        }
        if (this.$route.query.isinner && this.$route.query.isinner == 1) {
            this.hideHeader = true
        } else {
            this.hideHeader = false
        }
    },
    activated() {
        $("html,body").animate({scrollTop:"0px"},0)
    },
    mounted() {
        if (this._isWixin()) {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname
            getWXSDKSetting({
                title: '人才猎聘',
                desc: '让您的活动触达全球',
                link: link,
                imgUrl: 'http://img.capwhale.com/capwhale_logo.png'
            })
        }
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        showRecruitPop() {
            this.$refs.mtalentheader.openTeamwork()
        },
        goTop() {
            $("html,body").animate({scrollTop:"0px"},300)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['domainInfo', 'showAppTips'])
    },
    components: {
        MHeader, mTalentIndexContent
    }
}
</script>

<style lang="scss" type="text/scss">
.MTalentIndex {
    position: relative;
    padding: 0.88rem 0 0;
    background-color: #fff;
    min-height: 100vh;
    box-sizing: border-box;
    .m-body{
        font-family:PingFangSC-Medium,PingFang SC;
    }
    .serviceqrurl_pop {
        .van-popup--center {
            background: transparent;
            height: 6.1rem;
            .serviceqrurl_box {
                background-color: #fff;
                position: relative;
                width: 4.6rem;
                padding-top: 0.2rem;
                padding-bottom: 0.66rem;
                box-sizing: border-box;
                border-radius:0.15rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #333;
                .service_img {
                    width: 3rem;
                    height: 3rem;
                }
                .tip_text {
                    margin: 0.2rem 0;
                }
                .hot_line_text, .tip_text {
                    line-height:0.4rem;
                    font-size:0.28rem;
                    span {
                        color: #2E7FFF;
                    }
                }
                .close_img {
                    width: 0.6rem;
                    height: 0.6rem;
                    position: absolute;
                    bottom: -1rem;
                    left: 2rem;
                }
            }
        }
    }
    .shortcut_box {
        position: fixed;
        bottom: 1.8rem;
        right: 0.32rem;
        border-radius: 0.1rem;
        background:rgba(0,0,0,0.45);
        &>div {
            margin: 0 0.16rem;
            border-bottom: 0.01rem solid #FFF;
            width: 0.56rem;
            padding: 0.12rem 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #FFF;
            &>img {
                width: 0.4rem;
                height: 0.4rem;
                margin-bottom: 0.04rem;
            }
            &>span{
                font-size:0.18rem;
                line-height:0.25rem;
            }
        }
        &>div:nth-last-of-type(1){
            border-bottom: none;
        }
    }
    .gotop{
        position: fixed;
        right: 0.4rem;
        bottom: 1.76rem;
        width: 0.88rem;
        height: 0.88rem;
        opacity: 1;
    }
    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to{
        opacity: 0;
    }
}
</style>